import axios from 'axios';
import { API_URL } from '../components/common/constants';
import { getCookie } from './helpers';

// Function to fetch all users (for admin purposes)
export const getAllUsers = async (searchQuery = '') => {
  try {
    
    const token = localStorage.getItem('authToken');
    
    const response = await axios.get(`${API_URL}/users`, {
      params: { search: searchQuery },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.data.users || [];
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Function to switch to another user's profile
export const switchToUser = async (userId) => {
  try {
    const token = localStorage.getItem('authToken');
    const originalUser = JSON.parse(localStorage.getItem('originalUser') || 'null') || 
                        JSON.parse(localStorage.getItem('user'));
    
    // Store original user if not already stored (for switching back)
    if (!localStorage.getItem('originalUser')) {
      localStorage.setItem('originalUser', localStorage.getItem('user'));
      localStorage.setItem('originalAuthToken', token);
    }
    
    const response = await axios.post(`${API_URL}/switch-user`, { 
      targetUserId: userId,
      originalUserId: originalUser.userId || null
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log(response);

    if (response.data.success) {
      // Store the new user's token and profile
      localStorage.setItem('authToken', response.data.authToken);
      if (response.data.idToken) {
        localStorage.setItem('idToken', response.data.idToken);
      }
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('isImpersonating', 'true');
      
      // Update axios default headers
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.authToken}`;

      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Error switching user:', error);
    throw error;
  }
};

// Function to revert back to original admin user
export const revertToOriginalUser = async () => {
  try {
    const originalToken = localStorage.getItem('originalAuthToken');
    const originalUser = localStorage.getItem('originalUser');
    
    if (!originalToken || !originalUser) {
      throw new Error('Original user information not found');
    }
    
    // Restore original user data
    localStorage.setItem('authToken', originalToken);
    localStorage.setItem('user', originalUser);
    localStorage.removeItem('originalAuthToken');
    localStorage.removeItem('originalUser');
    localStorage.removeItem('isImpersonating');
    
    // Update axios default headers
    axios.defaults.headers.common['Authorization'] = `Bearer ${originalToken}`;
    
    return true;
  } catch (error) {
    console.error('Error reverting to original user:', error);
    throw error;
  }
};